import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import { revertAll } from "../revertAll"

type ChatbotState = {
  isPanelOpen: boolean
  selectedPersona: string
}

const initialState: ChatbotState = {
  isPanelOpen: false,
  selectedPersona: "cmo",
}

export const chatbotSlice = createSlice({
  name: "chatbotSlice",
  initialState,
  extraReducers: builder => builder.addCase(revertAll, () => initialState),
  reducers: {
    togglePanel(state) {
      state.isPanelOpen = !state.isPanelOpen
    },
    setPanel(state, { payload }: PayloadAction<boolean>) {
      state.isPanelOpen = payload
    },
    setPersona(state, { payload }: PayloadAction<string>) {
      state.selectedPersona = payload
    },
  },
})

export const chatbotActions = chatbotSlice.actions
